// Rotating Logo Bar Block JavaScript
document.addEventListener('DOMContentLoaded', function() {
  initRotatingLogoBars();
});

function initRotatingLogoBars() {
  const marquees = document.querySelectorAll('.rotating-marquee[data-marquee-id]');
  
  marquees.forEach(function(section) {
    const blockId = section.dataset.marqueeId;
    const track = section.querySelector('[data-marquee-track]');
    const originalContent = section.querySelector('[data-marquee-content]');
    
    if (!track || !originalContent) return;
    
    const initMarquee = function() {
      const contentWidth = originalContent.offsetWidth;
      const wrapper = section.querySelector('.marquee-wrapper');
      if (!wrapper) return;
      
      const containerWidth = wrapper.offsetWidth;
      if (contentWidth === 0) return;
      
      // Calculate how many copies we need for seamless loop
      const copiesNeeded = Math.max(2, Math.ceil((containerWidth * 2) / contentWidth) + 1);
      
      // Clear existing cloned content
      const existingClones = track.querySelectorAll('.marquee-clone');
      existingClones.forEach(function(clone) {
        clone.remove();
      });
      
      // Add required clones
      for (let i = 0; i < copiesNeeded - 1; i++) {
        const clone = originalContent.cloneNode(true);
        clone.classList.add('marquee-clone');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
    };
    
    // Run on load
    if (document.readyState === 'complete') {
      initMarquee();
    } else {
      window.addEventListener('load', initMarquee);
    }
    
    // Re-calculate on resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initMarquee, 250);
    });
  });
}

// Re-init when Shopify section is loaded/reloaded (for theme editor)
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initRotatingLogoBars, 100);
  });
}
